<template>
  <div>
    <Profile v-if="userExists" locked />

    <div class="mb-2">
      {{ trans('Please wait. You are being redirected.') }}
    </div>

    <div class="absolute bottom-2 left-2 right-2">
      <MdlProgressBar indeterminate class="rounded-[2px] overflow-hidden" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import { trans } from '@/munio/i18n'
import MdlProgressBar from '@component/mdl/ProgressBar.vue'
import Profile from './Profile.vue'

const $store = useStore()
const userExists = computed(() => $store.state.userExists && !$store.state.userInvited)
</script>
